import { Plugin } from 'prosemirror-state';

import { AddMenuBulleted, ListOutline } from '@lyearn/icons';
import { EditorOptions } from '@lyearn/lygo-core';

import { addMenuItemType } from '../../../types/menus';
import { addAddMenuBlock } from '../../../utils/menus';
import { NODE_NAME } from '../consts';

function plugins({ t }: EditorOptions): Plugin[] {
  return [
    new Plugin({
      view: (editorView) => {
        addAddMenuBlock(editorView, [
          {
            name: NODE_NAME,
            title: t('Lygo:Menu.bullet_list.title') as string,
            icon: ListOutline,
            addMenuIcon: AddMenuBulleted,
            addMenuItemType: addMenuItemType.basic_blocks,
            description: t('Lygo:Menu.bullet_list.description') as string,
            searchWords: ['text', 'list', 'bulleted List', 'basic'],
            isText: true,
          },
        ]);
        return {};
      },
    }),
  ];
}

export default plugins;
